import { render } from "./MsSplitButton.vue?vue&type=template&id=d8e28fcc&scoped=true"
import script from "./MsSplitButton.vue?vue&type=script&lang=js"
export * from "./MsSplitButton.vue?vue&type=script&lang=js"

import "./MsSplitButton.vue?vue&type=style&index=0&id=d8e28fcc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e28fcc"]])

export default __exports__